export const FETCH_AUTOMATION_LIST = 'FETCH_AUTOMATION_LIST';
export const FETCH_AUTOMATION_LIST_SUCCESS = 'FETCH_AUTOMATION_LIST_SUCCESS';
export const FETCH_AUTOMATION_LIST_FAIL = 'FETCH_AUTOMATION_LIST_FAIL';
export const FETCH_AUTOMATION_CUSTOMERS = 'FETCH_AUTOMATION_CUSTOMERS';
export const FETCH_AUTOMATION_CUSTOMERS_SUCCESS =
  'FETCH_AUTOMATION_CUSTOMERS_SUCCESS';
export const FETCH_AUTOMATION_CUSTOMERS_FAIL =
  'FETCH_AUTOMATION_CUSTOMERS_FAIL';
export const ADD_AUTOMATION = 'ADD_AUTOMATION';
export const ADD_AUTOMATION_SUCCESS = 'ADD_AUTOMATION_SUCCESS';
export const ADD_AUTOMATION_FAIL = 'ADD_AUTOMATION_FAIL';
export const SAVE_AUTOMATION = 'ADD_AUTOMATION';
export const SAVE_AUTOMATION_SUCCESS = 'ADD_AUTOMATION_SUCCESS';
export const SAVE_AUTOMATION_FAIL = 'ADD_AUTOMATION_FAIL';
export const UPDATE_AUTOMATION = 'UPDATE_AUTOMATION';
export const UPDATE_AUTOMATION_SUCCESS = 'UPDATE_AUTOMATION_SUCCESS';
export const UPDATE_AUTOMATION_FAIL = 'UPDATE_AUTOMATION_FAIL';
export const UPDATE_AUTOMATION_NAME = 'UPDATE_AUTOMATION_NAME';
export const UPDATE_AUTOMATION_NAME_SUCCESS = 'UPDATE_AUTOMATION_NAME_SUCCESS';
export const UPDATE_AUTOMATION_NAME_FAIL = 'UPDATE_AUTOMATION_NAME_FAIL';
export const UPDATE_AUTOMATION_FLAG = 'UPDATE_AUTOMATION_FLAG';
export const UPDATE_AUTOMATION_FLAG_SUCCESS = 'UPDATE_AUTOMATION_FLAG_SUCCESS';
export const UPDATE_AUTOMATION_FLAG_FAIL = 'UPDATE_AUTOMATION_FLAG_FAIL';
export const DELETE_AUTOMATION = 'DELETE_AUTOMATION';
export const DELETE_AUTOMATION_SUCCESS = 'DELETE_AUTOMATION_SUCCESS';
export const DELETE_AUTOMATION_FAIL = 'DELETE_AUTOMATION_FAIL';
export const UPDATE_VISIBLE_AUTOMATION = 'UPDATE_VISIBLE_AUTOMATION';
export const SET_VALUE_CHANGED = 'SET_VALUE_CHANGED';
export const SET_AUTOMATION_PRIORITY = 'SET_AUTOMATION_PRIORITY';
export const SET_AUTOMATION_PRIORITY_SUCCESS =
  'SET_AUTOMATION_PRIORITY_SUCCESS';
export const SET_AUTOMATION_PRIORITY_FAIL = 'SET_AUTOMATION_PRIORITY_FAIL';
export const RESET_AUTOMATION = 'RESET_AUTOMATION';

export const fetchAutomationCustomers = ({ automationId }) => ({
  type: FETCH_AUTOMATION_CUSTOMERS,
  payload: { automationId }
});

export const fetchAutomationCustomersSuccess = ({ customersList }) => ({
  type: FETCH_AUTOMATION_CUSTOMERS_SUCCESS,
  payload: { customersList }
});

export const fetchAutomationCustomersFail = (message) => ({
  type: FETCH_AUTOMATION_CUSTOMERS_FAIL,
  payload: { message }
});

export const fetchAutomationList = () => ({
  type: FETCH_AUTOMATION_LIST
});

export const fetchAutomationListSuccess = ({
  automationList,
  typologyActions
}) => ({
  type: FETCH_AUTOMATION_LIST_SUCCESS,
  payload: { automationList, typologyActions }
});

export const fetchAutomationListFail = (message) => ({
  type: FETCH_AUTOMATION_LIST_FAIL,
  payload: { message }
});

export const addAutomation = (automationData) => ({
  type: ADD_AUTOMATION,
  payload: { automationData }
});

export const addAutomationSuccess = () => ({
  type: ADD_AUTOMATION_SUCCESS
});

export const addAutomationFail = (message) => ({
  type: ADD_AUTOMATION_FAIL,
  payload: { message }
});

export const saveAutomation = ({ automationData }) => ({
  type: SAVE_AUTOMATION,
  payload: { automationData }
});

export const saveAutomationSuccess = ({ id }) => ({
  type: SAVE_AUTOMATION_SUCCESS,
  payload: { id }
});

export const saveAutomationFail = (message) => ({
  type: SAVE_AUTOMATION_FAIL,
  payload: { message }
});

export const updateAutomation = ({ id, configData }) => ({
  type: UPDATE_AUTOMATION,
  payload: { id, configData }
});

export const updateAutomationSuccess = () => ({
  type: UPDATE_AUTOMATION_SUCCESS
});

export const updateAutomationFail = (message) => ({
  type: UPDATE_AUTOMATION_FAIL,
  payload: { message }
});

export const updateAutomationName = ({ id, name }) => ({
  type: UPDATE_AUTOMATION_NAME,
  payload: { id, name }
});

export const updateAutomationNameSuccess = () => ({
  type: UPDATE_AUTOMATION_NAME_SUCCESS
});

export const updateAutomationNameFail = (message) => ({
  type: UPDATE_AUTOMATION_NAME_FAIL,
  payload: { message }
});

export const updateAutomationFlag = ({ id, enabled }) => ({
  type: UPDATE_AUTOMATION_FLAG,
  payload: { id, enabled }
});

export const updateAutomationFlagSuccess = () => ({
  type: UPDATE_AUTOMATION_FLAG_SUCCESS
});

export const updateAutomationFlagFail = (message) => ({
  type: UPDATE_AUTOMATION_FLAG_FAIL,
  payload: { message }
});

export const deleteAutomation = ({ id }) => ({
  type: DELETE_AUTOMATION,
  payload: { id }
});

export const deleteAutomationSuccess = () => ({
  type: DELETE_AUTOMATION_SUCCESS
});

export const deleteAutomationFail = (message) => ({
  type: DELETE_AUTOMATION_FAIL,
  payload: { message }
});

export const updateVisibleAutomation = (visibleAutomationId) => ({
  type: UPDATE_VISIBLE_AUTOMATION,
  payload: { visibleAutomationId }
});

export const setValueChanged = (isValueChanged) => ({
  type: SET_VALUE_CHANGED,
  payload: { isValueChanged }
});

export const setAutomationPriority = ({ priorityList }) => ({
  type: SET_AUTOMATION_PRIORITY,
  payload: { priorityList }
});

export const setAutomationPrioritySuccess = () => ({
  type: SET_AUTOMATION_PRIORITY_SUCCESS
});

export const setAutomationPriorityFail = (message) => ({
  type: SET_AUTOMATION_PRIORITY_FAIL,
  payload: { message }
});

export const resetAutomation = () => ({
  type: RESET_AUTOMATION
});

// export const addAutomationName = ({ name, type }) => ({
//   type: ADD_AUTOMATION_NAME,
//   payload: { name, type }
// });
